import React from 'react';
import Button from 'src/components/Button';
import FontAwesomeIcon from 'src/components/Icon';
import './ServiceRequestDashboardToolbar.scss';

interface ServiceRequestDashboardToolbarProps {
  children: React.ReactNode;
  canCreateServiceRequest?: boolean;
  onCreateServiceRequest?: () => void;
  createDisabled?: boolean;
}

const ServiceRequestDashboardToolbar = ({
  children,
  canCreateServiceRequest = false,
  onCreateServiceRequest,
  createDisabled = false,
}: ServiceRequestDashboardToolbarProps) => {
  const showCreateButton: boolean =
    canCreateServiceRequest && !!onCreateServiceRequest;

  return (
    <div className="service-request-dashboard-toolbar">
      <div className="service-request-dashboard-toolbar-actions">
        {children}
      </div>

      {showCreateButton && (
        <Button
          color="teal"
          label="Create Request"
          onClick={onCreateServiceRequest}
          icon={<FontAwesomeIcon glyph="wrench" weight="light" size="small" />}
          size="small"
          disabled={createDisabled}
        />
      )}
    </div>
  );
};

export default ServiceRequestDashboardToolbar;
